export function highlight(text: string, criteria: string) {
   if (!criteria) return text;

   criteria = criteria.replace('*', '');

   return text.replace(new RegExp(criteria, 'gi'), match =>
      `<span class="am-highlight-text">${match}</span>`
   );
}
